import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { GlobalSubheaderDataService } from "../global-subheader-data.service";
import { Dictionary } from "src/app/store/models/common_types";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
// import { takeUntil } from "rxjs/operators";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { Subject, Subscription } from "rxjs";
import { AppService } from "src/app/app.service";
import { PageParams } from "src/app/store/models/navigation-settings.model";
import { NzMessageService } from "ng-zorro-antd/message";

class BreadCrumbSection {
  name: string;
  link: string;
  isRouterLink?: boolean;
  sname?: string;
  constructor(n: string, l: string, sn?: string) {
    this.name = n;
    this.link = l;
    this.sname = sn;
    this.isRouterLink = false;
  }
}

@Component({
  selector: "app-subheader-breadcrumb",
  templateUrl: "./subheader-breadcrumb.component.html",
  styleUrls: ["./subheader-breadcrumb.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SubheaderBreadcrumbComponent implements OnInit, OnDestroy {
  breadCrumb: Array<BreadCrumbSection> = [];
  loading = true;
  legacyUrl: string;
  pageName: string;
  page: string;
  lastPathname: string;
  titleLink: string;
  ngDestroyed$ = new Subject();
  currentMagicKey: string; // Used to maintain a unique key telling us which tab is currently selected
  currentCut: string;
  currentSource: string;
  isFirstLoad = true;
  leftPanelTabName: string;
  tabsData: any;
  pageNavParams: PageParams;
  pageNameSubscriber: Subscription;
  tickerSubscriber: Subscription;
  subheaderChangedSubscriber: Subscription;
  leftPanelDataSubscriber: Subscription;
  pageParamsSubscriber: Subscription;
  breadcrumbCallSubscriber: Subscription;
  constructor(
    private dataService: GlobalSubheaderDataService,
    private store: Store<AppState>,
    private message: NzMessageService,
    private appService: AppService,
  ) {}

  ngOnInit(): void {
    this.legacyUrl = `${window.caUrl}/app`;
    if (this.pageNameSubscriber) {
      this.pageNameSubscriber.unsubscribe();
    }

    this.pageNameSubscriber = this.store
      .select(stateGetter("globalSubheader", "pageName"))
      .subscribe((data: string) => {
        if (this.lastPathname !== window.location.pathname && data !== "") {
          this.lastPathname = window.location.pathname;
          this.pageName = data;
          if (this.pageName === "reporting") {
            this.page = this.lastPathname.split("/")[2];
          }
          this.getBreadCrumbs();
        }
      });
    if (this.tickerSubscriber) {
      this.tickerSubscriber.unsubscribe();
    }

    this.tickerSubscriber = this.store
      .select(stateGetter("globalSubheader", "ticker"))
      .subscribe((data: string) => {
        if (this.lastPathname !== window.location.pathname && data !== "") {
          this.lastPathname = window.location.pathname;
          this.getBreadCrumbs();
        }
      });

    if (this.subheaderChangedSubscriber) {
      this.subheaderChangedSubscriber.unsubscribe();
    }

    this.subheaderChangedSubscriber = this.store
      .select(stateGetter("globalSubheader", "subheaderChanged"))
      .subscribe(() => {
        if (
          this.lastPathname !== undefined &&
          this.lastPathname !== window.location.pathname
        ) {
          this.lastPathname = window.location.pathname;
          this.getBreadCrumbs();
        }
      });

    if (this.leftPanelDataSubscriber) {
      this.leftPanelDataSubscriber.unsubscribe();
    }

    this.leftPanelDataSubscriber = this.store
      .select(stateGetter("leftPanel", "data"))
      .subscribe((tabsData: any[]) => {
        this.tabsData = tabsData;

        if (!this.pageNavParams) {
          return;
        }
        const { pg, cut, ticker } = this.pageNavParams;
        if (!pg || !cut || !ticker) {
          return;
        }
        this.dispatchBreadCrumbEvent(ticker, cut, pg);
      });

    if (this.pageParamsSubscriber) {
      this.pageParamsSubscriber.unsubscribe();
    }

    this.pageParamsSubscriber = this.store
      .select(stateGetter("navigationSettings", "pageParams"))
      .subscribe((pageNavParams: PageParams) => {
        if (this.isFirstLoad) {
          return;
        }

        const { pg, cut, ticker } = pageNavParams;
        this.pageNavParams = pageNavParams;
        if (!pg || !cut || !ticker) {
          return;
        }

        if (this.lastPathname !== window.location.pathname) {
          this.lastPathname = window.location.pathname;
          const breadCrumbCall = this.getBreadCrumbs();
          if (breadCrumbCall) {
            breadCrumbCall.add(() => {
              if (!this.tabsData[ticker]) {
                return;
              }
              this.dispatchBreadCrumbEvent(ticker, cut, pg);
            });
          }
        }
      });

    //Adding this to change the full name in the breadcrumb on tab switch in the mex page
    window.addEventListener(
      "changeBreadCrumbDetail",
      this.changeBreadCrumbDetail.bind(this),
    );

    window.addEventListener(
      "changeBreadCrumbDetailFromLPForMex",
      this.changeBreadCrumbDetailFromLPForMex.bind(this),
    );
  }
  getBreadCrumbs(callOnLeftPanelLinkClick = "n") {
    if (this.pageName === "") {
      return null;
    }
    const params = this.getParams();
    let breadcrumbCall = null;
    if (params !== "") {
      this.breadcrumbCallSubscriber = breadcrumbCall = this.dataService
        .getBreadcrumbsData(params)
        .subscribe(
          (response) => {
            if (response.breadcrumb_dict) {
              const breadsList = response.breadcrumb_dict.map(
                (breadcrumbObj: Dictionary<string>) => {
                  return new BreadCrumbSection(
                    breadcrumbObj.name,
                    breadcrumbObj.link,
                    breadcrumbObj.sname,
                  );
                },
              );
              this.breadCrumbLinkSwitch(breadsList);
              this.breadCrumb = breadsList;
              this.setSubheaderTitle(response);

              // Adding this to handle left panel clicks from the mex page
              if (callOnLeftPanelLinkClick === "y") {
                window.dispatchEvent(
                  new CustomEvent("changeBreadCrumbDetail", {
                    detail: {
                      tabName: this.leftPanelTabName,
                      cut: this.currentCut,
                    },
                  }),
                );
                window.dispatchEvent(new CustomEvent("bindMyTabClicks"));
              }
            } else {
              this.setSubheaderTitle({});
              // console.error("Could not find breadcrumb dictionary");
              // this.message.error(`Error: ${response.message}`, {
              //   nzDuration: 2000
              // });
              // setTimeout(() => {
              //   window.location.href = this.legacyUrl;
              // }, 2000);
            }
            this.loading = false;
          },
          () => {
            this.setSubheaderTitle({});
            this.loading = false;
            // this.message.error(`Error: ${err.message}`, {
            //   nzDuration: 2000
            // });
            // setTimeout(() => {
            //   window.location.href = this.legacyUrl;
            // }, 2000);
          },
        );
    }
    return breadcrumbCall;
  }
  changeBreadCrumbDetailFromLPForMex(data: any) {
    //data.detail.cut is to check for the normal NMV,SCH,STD
    //`${data.detail.cut}_${data.detail.source}` is to check for unique SAR tabs, by source
    if (
      this.currentMagicKey === data.detail.cut ||
      this.currentMagicKey === `${data.detail.cut}_${data.detail.source}`
    ) {
      if (this.breadCrumb && this.breadCrumb.length > 0) {
        const finalCrumb = this.breadCrumb[this.breadCrumb.length - 1].name;
        this.breadCrumb[this.breadCrumb.length - 1].name = `${
          finalCrumb.split("-")[0]
        } - ${data.detail.tabName}`;
      }
    } else {
      // Require a setTimeout() here since the URL hasn't changed yet and
      // the this.getParams() call uses the browser url to create the API params

      setTimeout(() => {
        this.leftPanelTabName = data.detail.tabName;
        this.getBreadCrumbs("y");
      }, 250);
    }

    //Updating the unique key after the click has triggered
    if (data.detail.cut !== "SAR") {
      this.currentMagicKey = data.detail.cut;
    } else {
      this.currentMagicKey = `${data.detail.cut}_${data.detail.source}`;
    }
  }
  changeBreadCrumbDetail(data: any) {
    if (!this.breadCrumb || this.breadCrumb.length === 0) {
      return;
    }

    if (this.isFirstLoad === true || this.currentCut === data.detail.cut) {
      const finalCrumb = this.breadCrumb[this.breadCrumb.length - 1].name;
      this.breadCrumb[this.breadCrumb.length - 1].name = `${
        finalCrumb.split("-")[0]
      } - ${data.detail.tabName}`;
      this.isFirstLoad = false;
    } else {
      if (this.currentCut !== data.detail.cut) {
        // Require a setTimeout() here since the URL hasn't changed yet and
        // the this.getParams() call uses the browser url to create the API params

        setTimeout(() => {
          this.leftPanelTabName = data.detail.tabName;
          this.getBreadCrumbs("y");
        }, 250);
      }
    }
    this.currentCut = data.detail.cut;
  }

  dispatchBreadCrumbEvent(ticker, cut, pg) {
    const tabGroups = this.tabsData[ticker].data;
    const selectedTabGroup = tabGroups.find(
      (tabGroup) => tabGroup.view === cut,
    );
    const selectedTab = selectedTabGroup.values.find(
      (tab) => tab.shortName === pg,
    );

    this.currentCut = cut;
    if (selectedTab !== undefined) {
      this.leftPanelTabName = selectedTab.label;

      window.dispatchEvent(
        new CustomEvent("changeBreadCrumbDetail", {
          detail: {
            tabName: this.leftPanelTabName,
            cut: this.currentCut,
          },
        }),
      );
    }
  }

  getParams() {
    let params = "";
    let industryName = "";
    let companyTicker = "";
    let sectorName = "";
    let brokerName = "";
    let analystId = "";
    let companyCut = "";
    let companyPg = "";
    let companySource = "";
    let bbgTickerType = "";
    let tickerType = "";
    switch (this.pageName) {
      case "charts":
        industryName = decodeURIComponent(
          window.location.pathname.split("/")[3],
        );
        params = `page=charts`;
        break;
      case "research":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=research_company&ticker=${companyTicker}`;
        break;
      case "sectors_industries":
        params = "page=sectors_industries";
        break;
      case "company":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=company&ticker=${companyTicker}`;
        break;
      case "allbrokers":
        params = `page=allbrokerpage`;
        break;
      case "sector":
        sectorName = decodeURIComponent(window.location.pathname.split("/")[3]);
        params = `page=sector_page&sector=${encodeURIComponent(sectorName)}`;
        break;
      case "broker":
        brokerName = decodeURIComponent(window.location.pathname.split("/")[3]);
        params = `page=broker&broker=${encodeURIComponent(brokerName)}`;
        break;
      case "analyst":
        analystId = decodeURIComponent(window.location.pathname.split("/")[3]);
        params = `page=analyst_page&analyst_id=${encodeURIComponent(
          analystId,
        )}`;
        break;
      case "models":
        params = `page=models`;
        break;
      case "industry":
        industryName = decodeURIComponent(
          window.location.pathname.split("/")[4],
        );
        params = `page=industry_page&industry_name=${encodeURIComponent(
          industryName,
        )}`;
        break;
      case "allcompany":
        params = `page=allcompanypage`;
        break;
      case "watchlist":
        params = "page=watchlist";
        break;
      case "entitlements":
        params = `page=entitlement_page`;
        break;
      case "research_document":
        params = `page=research_document`;
        break;
      case "mex":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        companyCut = window.location.pathname.split("/")[3].toUpperCase();
        if (companyCut === "SAR") {
          companySource = window.location.pathname.split("/")[5].toUpperCase();
          companyPg = window.location.pathname.split("/")[4];
          params = `page=mex&ticker=${companyTicker}&cut=${companyCut}&source=${companySource}&pg=${companyPg}`;
          break;
        }
        companyPg = window.location.pathname.split("/")[4].toUpperCase();
        params = `page=mex&cut=${companyCut}&pg=${companyPg}&ticker=${companyTicker}`;
        break;
      case "comps":
        params = `page=comps`;
        break;
      case "alert_settings":
        params = "page=alert_settings";
        break;
      case "revisions":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        bbgTickerType = window.location.pathname.split("/")[4];
        if (bbgTickerType !== undefined) {
          tickerType = `&tickertype=b`;
        }
        params = `page=revision&ticker=${companyTicker}${tickerType}`;
        break;
      case "surprise":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=surprise&ticker=${companyTicker}`;
        break;
      case "valuation":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=valuation&ticker=${companyTicker}`;
        break;
      case "nav":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=nav&ticker=${companyTicker}`;
        break;
      case "tpr":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=tpr&ticker=${companyTicker}`;
        break;
      case "events":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=events&ticker=${companyTicker}`;
        break;
      case "vsconsensus":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=vsconsensus&ticker=${companyTicker}`;
        break;
      case "analystdashboard":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        params = `page=analystdashboard&ticker=${companyTicker}`;
        break;
      case "embargomanagement":
        params = `page=embargo_management`;
        break;
      case "labs":
        params = `page=labs`;
        break;
      case "biopharma":
        params = `page=biopharma`;
        break;
      case "biopharma-database":
        params = `page=biopharma`;
        break;
      case "biopharma-drug":
        params = `page=biopharma`;
        break;
      case "apitutorials":
        params = `page=apitutorials`;
        break;
      case "templatelibrary":
        params = `page=templatelibrary`;
        break;
      default:
        params = "";
    }
    return params;
  }

  setSubheaderTitle(response: any) {
    let companyTicker = "";
    let industryName = "";
    let brokerName = "";
    let sectorName = "";
    let bbgTickerType = "";
    switch (this.pageName) {
      case "research":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "charts":
        // industryName = window.location.pathname.split("/")[3];
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `Charts`,
            sup: "",
            link: "",
          }),
        );
        break;
      case "templatelibrary":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `Template Library`,
            sup: "",
            link: "",
          }),
        );
        break;
      case "valuation":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "nav":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "tpr":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "sectors_industries":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Sectors and Industries",
            sup: "",
            link: "",
          }),
        );
        break;
      case "company":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: "",
          }),
        );
        break;
      case "allbrokers":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Broker Page",
            sup: "",
            link: "",
          }),
        );
        break;
      case "sector":
        sectorName = window.location.pathname.split("/")[3];
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${sectorName}`,
            sup: "",
            link: "",
          }),
        );
        break;
      case "broker":
        brokerName = response.breadcrumb_dict[2].name;
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${brokerName}`,
            sup: "",
            link: "",
          }),
        );
        break;
      case "analyst":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.breadcrumb_dict[3].name}`,
            sup: "",
            link: "",
          }),
        );
        break;
      case "models":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `Model Library`,
            sup: "",
            link: "",
          }),
        );
        break;
      case "industry":
        industryName = window.location.pathname.split("/")[4];
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${industryName}`,
            sup: "",
            link: "",
          }),
        );
        break;
      case "allcompany":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "All Companies",
          }),
        );
        break;
      case "watchlist":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Watchlist",
          }),
        );
        break;
      case "entitlements":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Entitlements",
            sup: "",
            link: "",
          }),
        );
        break;
      case "research_document":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Research Document",
          }),
        );
        break;
      case "comps":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Peer Analysis",
            sup: "",
            link: "",
          }),
        );
        break;
      case "mex":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "alert_settings":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Alert Settings",
            sup: "",
            link: "",
          }),
        );
        break;
      case "revisions":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        bbgTickerType = window.location.pathname.split("/")[4];
        this.dispatchSubheaderActionEvent(
          companyTicker,
          bbgTickerType,
          response,
        );
        break;
      case "surprise":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "events":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "vsconsensus":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "analystdashboard":
        companyTicker = window.location.pathname.split("/")[2].toUpperCase();
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: `${response.company_name ? response.company_name : ""}`,
            sup: `(${companyTicker})`,
            link: `${this.titleLink}`,
          }),
        );
        break;
      case "embargomanagement":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Embargo Management",
            sup: "",
            link: "",
          }),
        );
        break;
      case "labs":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "Labs",
          }),
        );
        break;
      case "apitutorials":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "API Tutorials",
          }),
        );
        break;
      case "biopharma":
      case "biopharma-database":
      case "biopharma-drug":
        this.store.dispatch(
          new GlobalSubheaderActions.SubheaderTitleChanged({
            title: "BioPharma",
          }),
        );
        break;
      default:
        break;
    }
  }

  breadCrumbLinkSwitch(breadList: Array<BreadCrumbSection>): void {
    let sectorName = "";
    breadList.forEach((bread: BreadCrumbSection) => {
      let urlB = "";

      switch (bread.link) {
        case "home":
          urlB = "/home";
          bread.isRouterLink = true;
          break;
        case "sectors_industries":
          urlB = "/sectors_industries";
          bread.isRouterLink = true;
          break;
        case "allbrokerpage":
          urlB = `/reporting/allbrokers`;
          bread.isRouterLink = true;
          break;
        case "sector_page":
          sectorName = bread.name;
          urlB = `/reporting/sector/${bread.name}`;
          bread.isRouterLink = true;
          break;
        case "industry_page":
          if (sectorName === "") {
            sectorName = breadList.filter((val) => {
              return val.link === "sector_page";
            })[0].name;
          }
          urlB = `/reporting/industry/${sectorName}/${bread.name}`;
          break;
        case "industry_analysis":
          urlB = `/comparative-analysis/current?comp_type=industry&id=${bread.sname}&sub_id=-1`;
          break;
        case "industryHome":
          urlB = `${this.legacyUrl}/industryHome/${bread.name}`;
          this.titleLink = `${this.legacyUrl}/${urlB}`;
          break;
        case "company":
          urlB = `/company/${bread.name}`;
          this.titleLink = `${urlB}`;
          bread.isRouterLink = true;
          break;
        case "watchlist":
          urlB = "";
          this.titleLink = ``;
          break;
        case "alert_settings":
          urlB = "";
          this.titleLink = ``;
          break;
        case "broker":
          urlB = `/reporting/broker/${bread.sname}`;
          bread.isRouterLink = true;
          break;
        case "":
        default:
          urlB = "";
          break;
      }
      bread.link = urlB;
    });
  }
  ngOnDestroy() {
    this.ngDestroyed$.next();
    this.pageName = "";
    window.removeEventListener(
      "changeBreadCrumbDetailFromLPForMex",
      this.changeBreadCrumbDetailFromLPForMex,
    );
    window.removeEventListener(
      "changeBreadCrumbDetail",
      this.changeBreadCrumbDetail,
    );
    if (this.breadcrumbCallSubscriber) {
      this.breadcrumbCallSubscriber.unsubscribe();
    }
    if (this.tickerSubscriber) {
      this.tickerSubscriber.unsubscribe();
    }
    if (this.subheaderChangedSubscriber) {
      this.subheaderChangedSubscriber.unsubscribe();
    }
    if (this.pageNameSubscriber) {
      this.pageNameSubscriber.unsubscribe();
    }
    if (this.pageParamsSubscriber) {
      this.pageParamsSubscriber.unsubscribe();
    }
    if (this.leftPanelDataSubscriber) {
      this.leftPanelDataSubscriber.unsubscribe();
    }
  }

  dispatchSubheaderActionEvent(companyTicker, bbgTickerType, response) {
    if (bbgTickerType !== undefined) {
      const vaTickerSet = this.store
        .select(stateGetter("navigationSettings", "pageParams", "ticker"))
        .subscribe((ticker: string) => {
          if (ticker !== undefined) {
            this.store.dispatch(
              new GlobalSubheaderActions.SubheaderTitleChanged({
                title: `${response.company_name ? response.company_name : ""}`,
                sup: `(${ticker})`,
                link: `${this.titleLink}`,
              }),
            );

            if (vaTickerSet) {
              vaTickerSet.unsubscribe();
            }
          }
        });
    } else {
      this.store.dispatch(
        new GlobalSubheaderActions.SubheaderTitleChanged({
          title: `${response.company_name ? response.company_name : ""}`,
          sup: `(${companyTicker})`,
          link: `${this.titleLink}`,
        }),
      );
    }
  }

  onBreadcrumbClick(breadcrumbText) {
    this.logUserAction("BREADCRUMB_CLICK", breadcrumbText);
  }

  logUserAction(feature, value) {
    this.appService.logUserAction(
      {},
      "",
      "",
      feature,
      {
        URL: window.location.toString(),
        UTCTIME: new Date().toUTCString(),
        VALUE: value,
      },
      "",
      null,
    );
  }
}
